/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Title_ResetInputs */



/**
* | output |
* | --- |
* | "Reset Password" |
*
* @param {Auth_Verify_Title_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_title_reset = /** @type {((inputs?: Auth_Verify_Title_ResetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Title_ResetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser le mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Redefinir Senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta Password")
	return /** @type {LocalizedString} */ ("Reset Password")
});